import React, { useMemo, useState } from 'react';
import styled from 'styled-components';

import { WindowDropDowns } from 'components';
import dropDownData from './dropDownData';

import go from 'assets/windowsIcons/290.png';
import search from 'assets/windowsIcons/299(32x32).png';
import back from 'assets/windowsIcons/back.png';
import forward from 'assets/windowsIcons/forward.png';
import up from 'assets/windowsIcons/up.png';
import viewInfo from 'assets/windowsIcons/view-info.ico';
import folderOpen from 'assets/windowsIcons/337(32x32).png';
import folderSmall from 'assets/windowsIcons/318(16x16).png';
import computerSmall from 'assets/windowsIcons/676(16x16).png';
import documentSmall from 'assets/windowsIcons/308(16x16).png';
import networkSmall from 'assets/windowsIcons/693(16x16).png';
import removeSmall from 'assets/windowsIcons/302(16x16).png';
import controlSmall from 'assets/windowsIcons/300(16x16).png';
import menu from 'assets/windowsIcons/358(32x32).png';
import dropdown from 'assets/windowsIcons/dropdown.png';
import pullup from 'assets/windowsIcons/pullup.png';
import windows from 'assets/windowsIcons/windows.png';
import picturesIcon from 'assets/windowsIcons/307(32x32).png';

const IMAGE_RE = /\.(png|jpe?g|webp|gif|svg|avif)$/i;
const MEDIA_RE = /\.(png|jpe?g|webp|gif|svg|avif|mp4|webm|mov|m4v)$/i;

// eslint-disable-next-line import/no-webpack-loader-syntax
const artContext = require.context(
  '../../../assets/art',
  false,
  /\.(png|jpe?g|webp|gif|svg|avif|mp4|webm|mov|m4v)$/i,
);

function loadItems() {
  return artContext
    .keys()
    .filter(k => MEDIA_RE.test(k))
    .map(key => {
      const filename = key.replace(/^\.\//, '');
      return {
        key,
        filename,
        url: artContext(key),
        type: IMAGE_RE.test(filename) ? 'image' : 'video',
      };
    })
    .sort((a, b) =>
      a.filename.localeCompare(b.filename, undefined, { numeric: true }),
    );
}

function MyArt({ onClose }) {
  const items = useMemo(loadItems, []);
  const [selected, setSelected] = useState(null);
  const [thumbFailed, setThumbFailed] = useState({});

  const selectIndex = selected
    ? items.findIndex(i => i.key === selected.key)
    : -1;

  function step(delta) {
    if (selectIndex < 0) return;
    const next = (selectIndex + delta + items.length) % items.length;
    setSelected(items[next]);
  }

  function onClickOptionItem(item) {
    if (item === 'Close') onClose();
    if (item === 'Refresh' || item === 'Thumbnails') {
      setSelected(null);
    }
  }

  const imageCount = items.filter(i => i.type === 'image').length;
  const videoCount = items.length - imageCount;

  return (
    <Div>
      <section className="com__toolbar">
        <div className="com__options">
          <WindowDropDowns
            items={dropDownData}
            onClickItem={onClickOptionItem}
          />
        </div>
        <img className="com__windows-logo" src={windows} alt="windows" />
      </section>

      <section className="com__function_bar">
        <div className="com__function_bar__button--disable">
          <img className="com__function_bar__icon" src={back} alt="" />
          <span className="com__function_bar__text">Back</span>
          <div className="com__function_bar__arrow" />
        </div>
        <div className="com__function_bar__button--disable">
          <img className="com__function_bar__icon" src={forward} alt="" />
          <div className="com__function_bar__arrow" />
        </div>
        <div className="com__function_bar__button--disable">
          <img className="com__function_bar__icon--normalize" src={up} alt="" />
        </div>
        <div className="com__function_bar__separate" />
        <div className="com__function_bar__button">
          <img
            className="com__function_bar__icon--normalize "
            src={search}
            alt=""
          />
          <span className="com__function_bar__text">Search</span>
        </div>
        <div className="com__function_bar__button">
          <img
            className="com__function_bar__icon--normalize"
            src={folderOpen}
            alt=""
          />
          <span className="com__function_bar__text">Folders</span>
        </div>
        <div className="com__function_bar__separate" />
        <div className="com__function_bar__button">
          <img
            className="com__function_bar__icon--margin12"
            src={menu}
            alt=""
          />
          <div className="com__function_bar__arrow" />
        </div>
      </section>

      <section className="com__address_bar">
        <div className="com__address_bar__title">Address</div>
        <div className="com__address_bar__content">
          <img
            src={picturesIcon}
            alt="folder"
            className="com__address_bar__content__img"
          />
          <div className="com__address_bar__content__text">
            C:\lottel\My Documents\My Art
          </div>
          <img
            src={dropdown}
            alt="dropdown"
            className="com__address_bar__content__img"
          />
        </div>
        <div className="com__address_bar__go">
          <img className="com__address_bar__go__img" src={go} alt="go" />
          <span className="com__address_bar__go__text">Go</span>
        </div>
      </section>

      <div className="com__content">
        <div className="com__content__inner">
          <div className="com__content__left">
            <div className="com__content__left__card">
              <div className="com__content__left__card__header">
                <div className="com__content__left__card__header__text">
                  Picture Tasks
                </div>
                <img
                  src={pullup}
                  alt=""
                  className="com__content__left__card__header__img"
                />
              </div>
              <div className="com__content__left__card__content">
                <div
                  className="com__content__left__card__row"
                  onClick={() => items[0] && setSelected(items[0])}
                >
                  <img
                    className="com__content__left__card__img"
                    src={viewInfo}
                    alt=""
                  />
                  <div className="com__content__left__card__text link">
                    View as a slide show
                  </div>
                </div>
                <div className="com__content__left__card__row">
                  <img
                    className="com__content__left__card__img"
                    src={removeSmall}
                    alt=""
                  />
                  <div className="com__content__left__card__text link">
                    Order prints online
                  </div>
                </div>
                <div className="com__content__left__card__row">
                  <img
                    className="com__content__left__card__img"
                    src={controlSmall}
                    alt=""
                  />
                  <div className="com__content__left__card__text link">
                    Print pictures
                  </div>
                </div>
              </div>
            </div>

            <div className="com__content__left__card">
              <div className="com__content__left__card__header">
                <div className="com__content__left__card__header__text">
                  File and Folder Tasks
                </div>
                <img
                  src={pullup}
                  alt=""
                  className="com__content__left__card__header__img"
                />
              </div>
              <div className="com__content__left__card__content">
                <div className="com__content__left__card__row">
                  <img
                    className="com__content__left__card__img"
                    src={folderSmall}
                    alt=""
                  />
                  <div className="com__content__left__card__text link">
                    Make a new folder
                  </div>
                </div>
                <div className="com__content__left__card__row">
                  <img
                    className="com__content__left__card__img"
                    src={networkSmall}
                    alt=""
                  />
                  <div className="com__content__left__card__text link">
                    Publish this folder to the Web
                  </div>
                </div>
                <div className="com__content__left__card__row">
                  <img
                    className="com__content__left__card__img"
                    src={documentSmall}
                    alt=""
                  />
                  <div className="com__content__left__card__text link">
                    Share this folder
                  </div>
                </div>
              </div>
            </div>

            <div className="com__content__left__card">
              <div className="com__content__left__card__header">
                <div className="com__content__left__card__header__text">
                  Other Places
                </div>
                <img
                  src={pullup}
                  alt=""
                  className="com__content__left__card__header__img"
                />
              </div>
              <div className="com__content__left__card__content">
                <div className="com__content__left__card__row">
                  <img
                    className="com__content__left__card__img"
                    src={documentSmall}
                    alt=""
                  />
                  <div className="com__content__left__card__text link">
                    My Documents
                  </div>
                </div>
                <div className="com__content__left__card__row">
                  <img
                    className="com__content__left__card__img"
                    src={folderSmall}
                    alt=""
                  />
                  <div className="com__content__left__card__text link">
                    Shared Pictures
                  </div>
                </div>
                <div className="com__content__left__card__row">
                  <img
                    className="com__content__left__card__img"
                    src={computerSmall}
                    alt=""
                  />
                  <div className="com__content__left__card__text link">
                    My Computer
                  </div>
                </div>
                <div className="com__content__left__card__row">
                  <img
                    className="com__content__left__card__img"
                    src={networkSmall}
                    alt=""
                  />
                  <div className="com__content__left__card__text link">
                    My Network Places
                  </div>
                </div>
              </div>
            </div>

            <div className="com__content__left__card">
              <div className="com__content__left__card__header">
                <div className="com__content__left__card__header__text">
                  Details
                </div>
                <img
                  src={pullup}
                  alt=""
                  className="com__content__left__card__header__img"
                />
              </div>
              <div className="com__content__left__card__content">
                <div className="com__content__left__card__row">
                  <div className="com__content__left__card__text bold black">
                    My Art
                  </div>
                </div>
                <div className="com__content__left__card__row">
                  <div className="com__content__left__card__text black">
                    File Folder
                  </div>
                </div>
                <div className="com__content__left__card__row">
                  <div className="com__content__left__card__text black">
                    {items.length} object{items.length === 1 ? '' : 's'}
                    {items.length > 0 && (
                      <>
                        {' \u00b7 '}
                        {imageCount} image{imageCount === 1 ? '' : 's'}
                        {videoCount > 0 &&
                          `, ${videoCount} video${videoCount === 1 ? '' : 's'}`}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="com__content__right">
            <div className="com__content__right__card">
              <div className="com__content__right__card__header">
                {items.length === 0 ? 'This folder is empty' : 'Image Files'}
              </div>
              <div className="com__content__right__card__content">
                {items.length === 0 ? (
                  <Empty>
                    <EmptyBig>Drop images or videos into</EmptyBig>
                    <code>src/assets/art/</code>
                    <EmptyHint>
                      Hot reload will pick them up within a second.
                    </EmptyHint>
                  </Empty>
                ) : (
                  items.map(item => (
                    <Tile
                      key={item.key}
                      type="button"
                      onClick={() => setSelected(item)}
                      title={item.filename}
                    >
                      <TileMedia>
                        {item.type === 'image' ? (
                          thumbFailed[item.key] ? (
                            <ThumbFallback>?</ThumbFallback>
                          ) : (
                            <Thumb
                              src={item.url}
                              alt={item.filename}
                              loading="lazy"
                              onError={() =>
                                setThumbFailed(f => ({
                                  ...f,
                                  [item.key]: true,
                                }))
                              }
                            />
                          )
                        ) : (
                          <VideoThumbWrap>
                            <video src={item.url} muted preload="metadata" />
                            <PlayGlyph aria-hidden>â–¶</PlayGlyph>
                            <VideoBadge>VIDEO</VideoBadge>
                          </VideoThumbWrap>
                        )}
                      </TileMedia>
                      <TileLabel>{item.filename}</TileLabel>
                    </Tile>
                  ))
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {selected && (
        <Lightbox
          onClick={() => setSelected(null)}
          onKeyDown={e => {
            if (e.key === 'Escape') setSelected(null);
            else if (e.key === 'ArrowLeft') step(-1);
            else if (e.key === 'ArrowRight') step(1);
          }}
          tabIndex={0}
          ref={el => el && el.focus()}
        >
          <LightboxClose
            type="button"
            aria-label="Close"
            onClick={e => {
              e.stopPropagation();
              setSelected(null);
            }}
          >
            Ã—
          </LightboxClose>
          {items.length > 1 && (
            <LightboxNav
              type="button"
              aria-label="Previous"
              data-side="left"
              onClick={e => {
                e.stopPropagation();
                step(-1);
              }}
            >
              â€¹
            </LightboxNav>
          )}
          <LightboxInner onClick={e => e.stopPropagation()}>
            {selected.type === 'image' ? (
              <FullImg src={selected.url} alt={selected.filename} />
            ) : (
              <FullVideo src={selected.url} controls autoPlay playsInline />
            )}
            <LightboxCaption>
              {selected.filename}
              {items.length > 1 && (
                <LightboxIndex>
                  {' \u00b7 '}
                  {selectIndex + 1} of {items.length}
                </LightboxIndex>
              )}
            </LightboxCaption>
          </LightboxInner>
          {items.length > 1 && (
            <LightboxNav
              type="button"
              aria-label="Next"
              data-side="right"
              onClick={e => {
                e.stopPropagation();
                step(1);
              }}
            >
              â€º
            </LightboxNav>
          )}
        </Lightbox>
      )}
    </Div>
  );
}

const Div = styled.div`
  height: 100%;
  width: 100%;
  position: absolute;
  display: flex;
  overflow: hidden;
  flex-direction: column;
  background: linear-gradient(to right, #edede5 0%, #ede8cd 100%);

  .com__toolbar {
    position: relative;
    display: flex;
    align-items: center;
    line-height: 100%;
    height: 24px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.7);
    flex-shrink: 0;
  }
  .com__options {
    height: 23px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    border-right: 1px solid rgba(0, 0, 0, 0.1);
    padding: 1px 0 1px 2px;
    border-left: 0;
    flex: 1;
  }
  .com__windows-logo {
    height: 100%;
    border-left: 1px solid white;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }
  .com__function_bar {
    height: 36px;
    display: flex;
    align-items: center;
    font-size: 11px;
    padding: 1px 3px 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    flex-shrink: 0;
  }
  .com__function_bar__button {
    display: flex;
    height: 100%;
    align-items: center;
    border: 1px solid rgba(0, 0, 0, 0);
    border-radius: 3px;
    &:hover {
      border: 1px solid rgba(0, 0, 0, 0.1);
      box-shadow: inset 0 -1px 1px rgba(0, 0, 0, 0.1);
    }
    &:hover:active {
      border: 1px solid rgb(185, 185, 185);
      background-color: #dedede;
      box-shadow: inset 0 -1px 1px rgba(255, 255, 255, 0.7);
      color: rgba(255, 255, 255, 0.7);
      & > * {
        transform: translate(1px, 1px);
      }
    }
  }
  .com__function_bar__button--disable {
    filter: grayscale(1);
    opacity: 0.7;
    display: flex;
    height: 100%;
    align-items: center;
    border: 1px solid rgba(0, 0, 0, 0);
  }
  .com__function_bar__text {
    margin-right: 4px;
  }
  .com__function_bar__icon {
    height: 30px;
    width: 30px;
    &--normalize {
      height: 22px;
      width: 22px;
      margin: 0 4px 0 1px;
    }
    &--margin12 {
      height: 22px;
      width: 22px;
      margin: 0 1px 0 2px;
    }
  }
  .com__function_bar__separate {
    height: 90%;
    width: 1px;
    background-color: rgba(0, 0, 0, 0.2);
    margin: 0 2px;
  }
  .com__function_bar__arrow {
    height: 100%;
    display: flex;
    align-items: center;
    margin: 0 4px;
    &:before {
      content: '';
      display: block;
      border-width: 3px 3px 0;
      border-color: #000 transparent;
      border-style: solid;
    }
  }
  .com__address_bar {
    flex-shrink: 0;
    border-top: 1px solid rgba(255, 255, 255, 0.7);
    height: 20px;
    font-size: 11px;
    display: flex;
    align-items: center;
    padding: 0 2px;
    box-shadow: inset 0 -2px 3px -1px #b0b0b0;
  }
  .com__address_bar__title {
    line-height: 100%;
    color: rgba(0, 0, 0, 0.5);
    padding: 5px;
  }
  .com__address_bar__content {
    border: rgba(122, 122, 255, 0.6) 1px solid;
    height: 100%;
    display: flex;
    flex: 1;
    align-items: center;
    background-color: white;
    position: relative;
    &__img {
      width: 14px;
      height: 14px;
    }
    &__img:last-child {
      width: 15px;
      height: 15px;
      right: 1px;
      position: absolute;
    }
    &__img:last-child:hover {
      filter: brightness(1.1);
    }
    &__text {
      white-space: nowrap;
      position: absolute;
      left: 16px;
      right: 17px;
    }
  }
  .com__address_bar__go {
    display: flex;
    align-items: center;
    padding: 0 18px 0 5px;
    height: 100%;
    position: relative;
    &__img {
      height: 95%;
      border: 1px solid rgba(255, 255, 255, 0.2);
      margin-right: 3px;
    }
  }

  .com__content {
    flex: 1;
    border: 1px solid rgba(0, 0, 0, 0.4);
    border-top-width: 0;
    background-color: #f1f1f1;
    overflow: auto;
    font-size: 11px;
    position: relative;
  }
  .com__content__inner {
    display: flex;
    height: 100%;
    overflow: auto;
  }
  .com__content__left {
    width: 180px;
    height: 100%;
    background: linear-gradient(to bottom, #748aff 0%, #4057d3 100%);
    overflow: auto;
    padding: 10px;
    flex-shrink: 0;
  }
  .com__content__left__card {
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    width: 100%;
    overflow: hidden;
  }
  .com__content__left__card:not(:last-child) {
    margin-bottom: 12px;
  }
  .com__content__left__card__header {
    display: flex;
    align-items: center;
    height: 23px;
    padding-left: 11px;
    padding-right: 2px;
    cursor: pointer;
    background: linear-gradient(
      to right,
      rgb(240, 240, 255) 0,
      rgb(240, 240, 255) 30%,
      rgb(168, 188, 255) 100%
    );
  }
  .com__content__left__card__header:hover {
    & .com__content__left__card__header__text {
      color: #1c68ff;
    }
  }
  .com__content__left__card__header__text {
    font-weight: 700;
    color: #0c327d;
    flex: 1;
  }
  .com__content__left__card__header__img {
    width: 18px;
    height: 18px;
    filter: drop-shadow(1px 1px 3px rgba(0, 0, 0, 0.3));
  }
  .com__content__left__card__content {
    padding: 5px 10px;
    background: linear-gradient(
      to right,
      rgb(180, 200, 251) 0%,
      rgb(164, 185, 251) 50%,
      rgb(180, 200, 251) 100%
    );
    background-color: rgba(198, 211, 255, 0.87);
  }
  .com__content__left__card__row {
    display: flex;
    margin-bottom: 2px;
  }
  .com__content__left__card__img {
    width: 14px;
    height: 14px;
    margin-right: 5px;
  }
  .com__content__left__card__text {
    font-size: 10px;
    line-height: 14px;
    color: #0c327d;
    &.black {
      color: #000;
    }
    &.bold {
      font-weight: bold;
    }
    &.link:hover {
      cursor: pointer;
      color: #2b72ff;
      text-decoration: underline;
    }
  }

  .com__content__right {
    height: 100%;
    overflow: auto;
    background-color: #fff;
    flex: 1;
  }
  .com__content__right__card__header {
    width: 300px;
    font-weight: 700;
    padding: 2px 0 3px 12px;
    position: relative;
    &:after {
      content: '';
      display: block;
      background: linear-gradient(to right, #70bfff 0, #fff 100%);
      position: absolute;
      bottom: 0;
      left: -12px;
      height: 1px;
      width: 100%;
    }
  }
  .com__content__right__card__content {
    display: flex;
    align-items: flex-start;
    padding-right: 0;
    flex-wrap: wrap;
    padding: 15px 15px 0;
    gap: 12px;
  }
`;

const Tile = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 8px 4px 4px;
  border: 1px solid transparent;
  border-radius: 3px;
  background: transparent;
  cursor: pointer;
  font: inherit;
  color: inherit;
  width: 130px;
  &:hover {
    background: #e5efff;
    border-color: #b0c8e8;
  }
  &:focus-visible {
    outline: 1px dotted #333;
    outline-offset: -2px;
  }
`;

const TileMedia = styled.div`
  width: 116px;
  height: 116px;
  border: 1px solid #a09f88;
  background: #f7f6ef;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  position: relative;
`;

const Thumb = styled.img`
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  display: block;
`;

const ThumbFallback = styled.div`
  color: #a0a0a0;
  font-size: 40px;
`;

const VideoThumbWrap = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    background: #000;
    display: block;
  }
`;

const PlayGlyph = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  padding-left: 3px;
`;

const VideoBadge = styled.span`
  position: absolute;
  bottom: 4px;
  right: 4px;
  background: rgba(0, 0, 0, 0.7);
  color: #fff;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.5px;
  padding: 2px 4px;
  border-radius: 2px;
`;

const TileLabel = styled.div`
  width: 100%;
  text-align: center;
  font-size: 11px;
  color: #202020;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const Empty = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 30px 20px;
  text-align: center;
  code {
    background: #f0f0e8;
    border: 1px solid #d0cdb8;
    padding: 3px 8px;
    font-family: 'Consolas', 'Courier New', monospace;
    font-size: 12px;
  }
`;

const EmptyBig = styled.div`
  font-size: 13px;
  font-weight: 700;
  color: #4a4a4a;
`;

const EmptyHint = styled.div`
  color: #666;
  font-size: 11px;
`;

const Lightbox = styled.div`
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  outline: none;
`;

const LightboxInner = styled.div`
  max-width: 90%;
  max-height: 90%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
`;

const FullImg = styled.img`
  max-width: 100%;
  max-height: calc(100% - 30px);
  object-fit: contain;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.7);
`;

const FullVideo = styled.video`
  max-width: 100%;
  max-height: calc(100% - 30px);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.7);
`;

const LightboxCaption = styled.div`
  color: #eee;
  font-size: 12px;
  text-align: center;
`;

const LightboxIndex = styled.span`
  color: #999;
`;

const LightboxClose = styled.button`
  position: absolute;
  top: 12px;
  right: 12px;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: none;
  background: rgba(255, 255, 255, 0.15);
  color: #fff;
  font-size: 24px;
  line-height: 1;
  cursor: pointer;
  &:hover {
    background: rgba(255, 255, 255, 0.3);
  }
`;

const LightboxNav = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  &[data-side='left'] {
    left: 12px;
  }
  &[data-side='right'] {
    right: 12px;
  }
  width: 44px;
  height: 60px;
  border: none;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.15);
  color: #fff;
  font-size: 32px;
  line-height: 1;
  cursor: pointer;
  &:hover {
    background: rgba(255, 255, 255, 0.3);
  }
`;

export default MyArt;
